import { makeStyles } from "tss-react/mui"
import { Stack, Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { useDateTime } from "../../../../../modules/localization/useDateTime"
import { AccordionSection } from "./AccordionSection"
import { formatEventTimeRange } from "./helpers"
import { SectionSubTitle } from "./common/ReceiptPrimitives"

const useStyles = makeStyles()((theme) => ({
    container: {
        paddingTop: "1rem",
        gap: ".625rem",
        [theme.breakpoints.down("sm")]: {
            paddingTop: 0,
            gap: "1.25rem",
        },
    },
    item: {
        paddingLeft: "1rem",
        [theme.breakpoints.down("sm")]: {
            paddingTop: 0,
        },
    },
}))
type ResourcesProps = Readonly<{
    resources: { name: string; tableSetups?: { name: string }[] }[]
    event: { start: string; end: string } | null
    defaultExpanded?: boolean
}>

export function Resources({ event, resources, defaultExpanded }: ResourcesProps) {
    const { classes } = useStyles()
    const dateTimeFactory = useDateTime()

    const formattedMeetingTime = formatEventTimeRange(event, dateTimeFactory)

    return (
        <LocalizedStrict id="confirm-order-dialog-resources" attrs={{ title: true }}>
            <AccordionSection title="Resources" isTitleBackground defaultExpanded={defaultExpanded}>
                <Stack className={classes.container}>
                    <SectionSubTitle
                        translationKey="confirm-order-dialog-booking-time"
                        translationVars={{ timeRange: formattedMeetingTime }}
                    >
                        Booking time: {formattedMeetingTime}
                    </SectionSubTitle>

                    {resources.map((resource, idx) => {
                        const tableSetups = resource?.tableSetups?.map((el) => el.name).join(", ")
                        return (
                            <Stack gap=".5rem" className={classes.item} key={idx}>
                                {resource?.name && <Typography variant="body1">{resource.name}</Typography>}
                                {tableSetups && <Typography variant="body1">{tableSetups}</Typography>}
                            </Stack>
                        )
                    })}
                </Stack>
            </AccordionSection>
        </LocalizedStrict>
    )
}
